import type { TemplateField } from "@care-by-ella/contracts";

// TES-1247 — what the template editor lets a clinician change on a field.
//
// An evaluator-pinned field keeps its key and kind (the screening rules read
// them); its copy stays editable. A field bound to the canonical question
// register (TemplateField.questionId) asks the register's question, so its
// copy, help, unit, bounds and options are locked too: the API refuses a
// draft where they differ, and the editor should not offer an edit that
// cannot be saved. Order, "obligatoriskt" and removing the field are the
// form's own choices and stay open.
export interface FieldLock {
  /** Key and kind. */
  structure: boolean;
  /** Question, help text, unit, bounds and options. */
  copy: boolean;
  /** The register binding as shown, e.g. "BLOOD_PRESSURE_PULSE · systolic". */
  question: string | null;
}

export function fieldLock(
  field: Pick<TemplateField, "evaluatorPinned" | "questionId" | "questionPart">,
): FieldLock {
  const question =
    field.questionId === undefined
      ? null
      : field.questionPart
        ? `${field.questionId} · ${field.questionPart}`
        : field.questionId;
  return {
    structure: field.evaluatorPinned || question !== null,
    copy: question !== null,
    question,
  };
}
